import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../screens/User/Home/Home.css";
import Typed from "react-typed";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.css";

const FirstSection = () => {
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div class="headingStyle" alt="Logo" />
      <div style={{ position: "absolute " }}>
        <div>
          <span
            className="heading1"
            // style={{
            //   display: "flex",
            //   justifyContent: "center",
            //   alignItems: "center",
            //   fontSize: "5rem ",
            //   borderBottom: "2px solid rgb(118, 102, 223)",
            //   textAlign: "center",
            // }}
          >
            <span
              style={{
                marginRight: 5,
                WebkitTextFillColor: "transparent",
                WebkitTextStroke: "2px rgb(118, 102, 223)",
              }}
            >
              Adnan
            </span>
            <span class="">Ahmed</span>
            <i style={{ color: "rgb(118, 102, 223)" }}>'</i>{" "}
          </span>
        </div>
        <div>
          <div
            id="simpleUsage"
            style={{ fontSize: "2rem ", textAlign: "center" }}
          >
            I am{" "}
            <Typed
              strings={[
                " FreeLancer",
                " Mobile App Developer",
                " Reactjs Developer",

                " Web Developer",
                " freelance developer and designer",
              ]}
              typeSpeed={40}
              backSpeed={50}
              // loop
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="mt-2"
          >
            <a
              className="asd"
              style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
              href="https://api.whatsapp.com/send?phone=923453048496&text=&source=&data="
              target="blank"
              data-tip="Whatsapp"
              data-place="left"
            >
              {/* <Icon size={32} icon={whatsapp} /> */}
              <i class="fab fa-whatsapp-square fa-2x"></i>
            </a>
            <a
              className="asd"
              style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
              href="https://github.com/fidato818"
              target="blank"
              data-tip="Github"
            >
              {/* <Icon size={32} icon={github} /> */}
              <i class="fab fa-github-square fa-2x"></i>
            </a>
            <a
              className="asd"
              style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
              href="https://www.facebook.com/millions818"
              target="blank"
              data-tip="Facebook"
            >
              {/* <Icon size={32} icon={facebookOfficial} /> */}
              <i class="fab fa-facebook-square fa-2x"></i>
            </a>
            <a
              className="asd"
              style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
              href="https://www.linkedin.com/in/adnan-ahmed-28160298/"
              target="blank"
              data-tip="linkedn"
            >
              <i class="fab fa-linkedin fa-2x"></i>
              {/* <Icon size={32} icon={linkedinSquare} /> */}
            </a>
            <a
              className="asd"
              style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
              href="https://twitter.com/AdnanAhmed_818"
              target="blank"
              data-tip="twitter"
            >
              {/* <Icon size={32} icon={twitter} /> */}
              <i class="fab fa-twitter-square fa-2x"></i>
            </a>
            <a
              className="asd"
              style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
              href="https://www.instagram.com/adnan_ahmed818/"
              target="blank"
              data-tip="Instagram"
            >
              <i class="fab fa-instagram fa-2x"></i>
            </a>
            <a
              className="asd"
              style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
              href="/project-video"
              // target="blank"
              data-tip="Youtube"
            >
              <i class="fab fa-youtube-square fa-2x"></i>
            </a>
          </div>

          {/* <i className="fab fa-twitter-square fa-2x"></i> */}
          {/* </div> */}
          {/* <button type="button" className="btn ">classNameName */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};
// }

FirstSection.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(FirstSection);
